module.exports = __webpack_public_path__ + "f5e2fc8253cf5e0c0a18f4cdb24892ed.MP3";